<template>
    <iframe :src="url">
   
    </iframe>
</template>

<script>

export default {
  props:['url'],
  watch:{
    url:function(n,o){
      // console.log(this.url,n,o,'kkk')
    }
  },
  beforeUpdate(){
    let href = window.location.href
    if(href.indexOf('?')>0){
      href = href.split("?")
      let actionUrl = href[1].split("=")[1]
      let payload =  JSON.parse(localStorage.getItem('token'))
      document.getElementById('token').value = payload.token
      document.getElementsByTagName('form')[0].action = actionUrl
      document.getElementById('submit').click()
    }
 
  }
}
</script>

<style>

</style>